import './event-popup.scss'

class EventPopup {
  constructor() {
    window.addEventListener('click', (e) => this.handlePopupTriggerClick(e), true)
  }

  handlePopupTriggerClick(event) {
    const popupOpenTrigger = event.target.closest('[data-event-popup-open]')
    const popupCloseTrigger = event.target.closest('[data-event-popup-close]')

    if (popupOpenTrigger) {
      const popup = document.querySelector(`[data-event-popup="${popupOpenTrigger.dataset.eventPopupOpen}"]`)

      popup?.showModal()
    }

    if (popupCloseTrigger) {
      const popup = event.target.closest('[data-event-popup]')

      popup?.close()
    }
  }
}

new EventPopup()
